import { render, staticRenderFns } from "./TestPaper.vue?vue&type=template&id=c3cb42a2&scoped=true"
import script from "./TestPaper.vue?vue&type=script&lang=js"
export * from "./TestPaper.vue?vue&type=script&lang=js"
import style0 from "./TestPaper.vue?vue&type=style&index=0&id=c3cb42a2&prod&lang=less"
import style1 from "./TestPaper.vue?vue&type=style&index=1&id=c3cb42a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cb42a2",
  null
  
)

export default component.exports